import angular from "angular";
import URLS from "./URLS";
import Permissions from "./permissions";
import Levels from "./levels";
import Settings from "./settings";

let constantsModule = angular.module("app.constants", [
  URLS,
  Permissions,
  Levels,
  Settings,
]).name;

export default constantsModule;



// WEBPACK FOOTER //
// ./client/app/constants/constants.js